
import makerjs from "makerjs";
/**
 * 计算两点间的弦长
 * @param {Object} p1 - 第一个点坐标 {x, y}
 * @param {Object} p2 - 第二个点坐标 {x, y}
 * @returns {number} 弦长值
 */
 function calculateChordLength(p1, p2) {
  const dx = p2.x - p1.x;
  const dy = p2.y - p1.y;
  return Math.sqrt(dx*dx + dy*dy);
}
//已知劣弧上两点坐标及半径，求圆心坐标劣弧中心点坐标。
function optimizedArcMidpoint(start, end, radius) {
  // 1. 预计算差值避免重复计算
  const dx = end.x - start.x;
  const dy = end.y - start.y;
  const dSquared = dx * dx + dy * dy;

  // 快速检查半径有效性
  if (dSquared > 4 * radius * radius) return null; // 使用平方比较避免开方运算

  // 2. 计算中点（仅需一次加法运算）
  const midX = (start.x + end.x) * 0.5;
  const midY = (start.y + end.y) * 0.5;

  // 3. 计算垂直向量（优化单位化过程）
  const invD = 1 / Math.sqrt(dSquared);
  const ux = dy * invD;  // 单位垂直向量x分量
  const uy = -dx * invD; // 单位垂直向量y分量

  // 4. 计算圆心（单解模式，直接选择劣弧圆心）
  const h = Math.sqrt(radius * radius - dSquared * 0.25);
  const center = {
    x: midX + h * ux,
    y: midY + h * uy
  };

  // 5. 向量法计算中点（优化单位化过程）
  const v1x = start.x - center.x;
  const v1y = start.y - center.y;
  const v2x = end.x - center.x;
  const v2y = end.y - center.y;

  // 单位向量相加
  const sumX = v1x + v2x;
  const sumY = v1y + v2y;
  const invLen = radius / Math.sqrt(sumX * sumX + sumY * sumY);

  return {
    x: center.x + sumX * invLen,
    y: center.y + sumY * invLen
  };
}
function C17(model, zoom, Param, fixedParam) {
  //w,h,w1,w2
  console.log("Param==", Param[0].param);
  console.log("Param==", Param[1].param);
  console.log("Param==", Param);
  var plate = model.plate, markers = model.markers, myZoom = zoom * 1,
    W = Param[0].param, W1 = Param[1].param, H = Param[2].param,R = Param[3].param, A = Param[4].param,  
    //  plate = model.plate, markers = model.markers,
    markShift = fixedParam.markShift * 1, markShiftTwo = fixedParam.markShiftTwo * 1,
    markShiftThree = fixedParam.markShiftThree * 1, markShiftFour = fixedParam.markShiftFour * 1, markHolesOneD = fixedParam.markHolesOneD * 1,

    r = R * 1 * myZoom,
    a = A * 1 * myZoom,
    w = W * 1 * myZoom,
    w1 = W1 * 1 * myZoom,
    hh = H * 1 * myZoom,
    radian=a*Math.PI/180,
    // x0 = X*1*myZoom,
    // y0 = Y*1*myZoom;
    oc=hh/Math.sin(radian),//o为两条直线交点组成的上三角形 斜边长度 
    ox=Math.cos(radian)*hh/Math.sin(radian),oy=hh,


    rh=(w1+oc)*Math.sin(radian),rw=(w1+oc)*Math.cos(radian),
    rh0=(w1+oc)/5*Math.sin(radian),rw0=(w1+oc)/5*Math.cos(radian),
    h=rh,

    markLeftW1Rx=3*markShift*Math.sin(radian),
    markLeftW1Ry=3*markShift*Math.cos(radian),
    x0 = 0,  y0 = 0,
    x1 = w+ox-rw, y1 = rh,
    x2 = w,  y2 = hh, 
    x3 = w,  y3 = 0, 
    rx0=rw0,ry0=rh0,
    glassH = h, glassW = w;
 
  const start = { x: x0, y: y0 };
  const end = {x: x1, y: y1  };
  const radius = r;
  // const midpoint = calculateArcMidpoint(start, end, radius);
  const midpoint = optimizedArcMidpoint(start, end, radius);
  console.log("输出劣弧中点坐标start=", start); // 输出劣弧中点坐标
  console.log("输出劣弧中点坐标end=", end); // 输出劣弧中点坐标
  console.log("输出劣弧中点坐标=", midpoint); // 输出劣弧中点坐标
  //  var aa=Circle_Center(x1,y1,x2,y2,r);
  //  console.log("aa====",aa);
  var xm = midpoint.x, ym = midpoint.y;

  console.log("输出劣弧中点坐标xm,ym=,rh,rw,a", xm, ym,rh,rw,a); // 输出劣弧中点坐标
  console.log("输出劣弧中点坐标Math.sin(45)=", Math.sin(radian)); // 输出劣弧中点坐标
  console.log("输出劣弧中点坐标Math.cos(45)=", Math.cos(radian)); // 输出劣弧中点坐标

  //计算中点坐标
  const mx = (x1 + x0) / 2;
  const my = (y1 + y0) / 2;

  if (r !== 0) {
    var TxtR = "R=" +R;
  } if (w !== 0) {
    var TxtW = W;
  } if (w1 !== 0) {
    var TxtW1 = "W1=" +W1;
  } if (a !== 0) {
    var TxtA = "A=" + A;
  } if (hh !== 0) {
    var TxtH = "H=" + H;
  }



  var drawAbnormalShapeC17 = {
    paths: {
      "ArcLine": new makerjs.paths.Arc([x0, y0], [x1, y1], r, false, true),
      "UPLine": new makerjs.paths.Line([x1, y1], [x2, y2]),
      "RightLine": new makerjs.paths.Line([x2, y2], [x3, y3]),
      "BottomLine": new makerjs.paths.Line([x3, y3], [x0, y0]),
    }
  };
  var drawAbnormalShapeC17MarkH = {
    paths: {
      
      // "ArcLine": new makerjs.paths.Arc([x2, y2], [x3, y3]),
    }
  };
  var drawAbnormalShapeC17MarkR = {
    paths: {
      "LeftLine": new makerjs.paths.Line([xm, ym], [mx, my]),
    }
  };
  var drawAbnormalShapeC17MarkW = {
    paths: {
      "BottomLine": new makerjs.paths.Line([x0, y0 - markShift], [x3, y3 - markShift]),
      "BotmShortLfline": new makerjs.paths.Line([x0, y0], [x0, y0 - 2 * markShift]),
      "BotmShortRTline": new makerjs.paths.Line([x3, y3], [x3, y3 - 2 * markShift]),
    }
    //  };

  };
  var drawAbnormalShapeC17MarkW1 = {
    paths: {
      "LeftShortLine": new makerjs.paths.Line([x1, y1], [x1+markLeftW1Rx, y1 + markLeftW1Ry]),
      "RightShortLine": new makerjs.paths.Line([x2, y2], [x2+markLeftW1Rx, y2 + markLeftW1Ry]),
      "Midline": new makerjs.paths.Line([x1+markLeftW1Rx/2, y1 + markLeftW1Ry/2], [x2+markLeftW1Rx/2, y2 + markLeftW1Ry/2]),
    }
    //  };

  };
  makerjs.model.addCaption(drawAbnormalShapeC17MarkW, TxtW, [x0, y0 - 2 * markShift], [x3, y3 - 2 * markShift]);//长度文字
  makerjs.model.addCaption(drawAbnormalShapeC17MarkW1, TxtW1, [x1+markLeftW1Rx, y1 + markLeftW1Ry], [x2+markLeftW1Rx, y2 + markLeftW1Ry]);//长度文字  
  makerjs.model.addCaption(drawAbnormalShapeC17MarkH, TxtH, [x2, y2/2], [x2+5*markShift, y2/2]);//宽度文字
  makerjs.model.addCaption(drawAbnormalShapeC17MarkR, TxtR, [mx + markShift, my- 2*markShift], [mx + 3 * markShift, my- 2*markShift]);//宽度文字

  plate = {
    models: {
      drawAbnormalShapeC17: drawAbnormalShapeC17,
    }
  };
  markers = {
    models: {
      drawAbnormalShapeC17: drawAbnormalShapeC17,
      drawAbnormalShapeC17MarkW: drawAbnormalShapeC17MarkW,
      drawAbnormalShapeC17MarkW1: drawAbnormalShapeC17MarkW1,
      drawAbnormalShapeC17MarkH: drawAbnormalShapeC17MarkH,
      drawAbnormalShapeC17MarkR: drawAbnormalShapeC17MarkR,
    }
  };

  /*****************************************************************************/
  //return { plate, markers, glassW, glassH }

  return { w, h, plate, markers }
};


export default C17;